<template>
	<div
		style="max-height:100vh; min-height:100vh; overflow: auto;"
		class="pr4 pb15"
	>
		<div v-for="(item, i) in localTree" :key="i">
			<aeg-steps-node :node="item" @node:select="selectNode" />
		</div>
	</div>
</template>

<script>
import AegStepsNode from "./AegStepsNode"

export default {
	components: { AegStepsNode },

	props: {
		tree: {
			type: Array,
			default: () => [],
			example: [{ title: "Name of step", id: "id-here", isSelected: false }]
		}
	},

	data() {
		return {
			localTree: [...this.tree]
		}
	},

	methods: {
		selectNode(node) {
			const newTree = JSON.parse(JSON.stringify(this.localTree))

			const recursion = arr => {
				arr.forEach(item => {
					item.isSelected = false
					if (item.id === node.id) item.isSelected = true
					if (item?.children?.length) recursion(item.children)
				})
			}

			recursion(newTree)
			this.localTree = newTree

			// emit up
			this.$emit("node:select", node)
		}
	}
}
</script>
